<dashboard-pnrr-component [isPublic]="true"></dashboard-pnrr-component>